import { Box, Heading } from "@chakra-ui/react";
import style from "./TermsAndConditions.module.css"
import TermsAndConitionText from "./TermsAndConitionText";
import { Navbar } from "../Common/Component/Navbar.component";
import { Footer } from "../Common/Component/Footer.component";

const TermsAndConditions = () => {
  return (
    <>
      <Navbar/>
      <Box className={style.wrapper} paddingTop={"90px"}>
        <Box className={style.container}>
          <Heading className={style.primary_Color}>
            Terms and Conditions
          </Heading>
            <TermsAndConitionText/>
        </Box>
      </Box>
      {/* <Box> */}
        <Footer/>
      {/* </Box> */}
    </>
  );
};

export default TermsAndConditions;
